module.exports = __webpack_public_path__ + "static/img/herder1.b12136eb.png";